var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardCsat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0875 29.7792L27.8375 22.4958L20.5541 27.2458C19.6041 27.0875 18.4958 27.4042 17.7833 28.1167C16.5166 29.3834 16.5166 31.3625 17.7833 32.6292C19.05 33.8959 21.0291 33.8959 22.2958 32.6292C23.0083 31.8375 23.2458 30.8083 23.0875 29.7792Z",
    stroke: "#212C42",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7083 24.8708C29.7375 26.4542 30.2916 28.3542 30.2916 30.3333H38.2083C38.2083 26.7708 37.1791 23.4458 35.4375 20.5958",
    stroke: "#212C42",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6917 12.2833C21.8208 12.2042 20.8708 12.125 20 12.125C9.94582 12.125 1.79166 20.2792 1.79166 30.3333H9.70832C9.70832 24.6333 14.3 20.0417 20 20.0417C21.8208 20.0417 23.5625 20.5167 25.0667 21.3875",
    stroke: "#212C42",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4792 19.25C35.1956 19.25 38.2083 16.2372 38.2083 12.5208C38.2083 8.80438 35.1956 5.79163 31.4792 5.79163C27.7628 5.79163 24.75 8.80438 24.75 12.5208C24.75 16.2372 27.7628 19.25 31.4792 19.25Z",
    stroke: "#212C42",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9167 13.7083C28.4708 15.1333 29.8958 16.0833 31.4792 16.0833C33.0625 16.0833 34.4875 15.1333 35.0417 13.7083",
    stroke: "#212C42",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardCsat);
export default __webpack_public_path__ + "static/media/dashboard_csat.c50d6c7a495267c4a5be108acaf07845.svg";
export { ForwardRef as ReactComponent };